export default __webpack_public_path__ + "static/media/correct.b8ee3de3.svg";